// Fix height of carousel on front page
$(function() {
  var $testimonials = $('#front-testimonials');

  if($testimonials.length > 0) {
    var maxHeight = 0;

    $testimonials.find('.carousel-item').each(function(index, element) {
      if($(element).height() > maxHeight) {
        maxHeight = $(element).height();
      }
    });

    $testimonials.find('.carousel-item').each(function(index, element) {
      $(element).css('height', maxHeight);
    });
  }
});